export const ALLOCATED_COLOR = '#0c6e47';
export const ALLOCATED_COLOR_RGBA = [12, 110, 71, 0.9];
export const ALLOCATED_COLOR_NO_OPACITY_RGBA = [12, 110, 71, 1.0];
export const AVAILABLE_COLOR = '#2c24c3';
export const AVAILABLE_COLOR_RGBA = [44, 36, 195, 0.8];
export const AVAILABLE_COLOR_NO_OPACITY_RGBA = [44, 36, 195, 1.0];
export const SELECTED_COLOR_RGBA = [18, 159, 103, 1.0];
export const UNAVAILABLE_COLOR = '#e42e4f';
export const UNAVAILABLE_COLOR_RGBA = [190, 18, 52, 0.7];
export const UNAVAILABLE_COLOR_ORANGE_RGBA = [245, 158, 11, 0.7];
export const UNAVAILABLE_COLOR_NO_OPACITY_ORANGE_RGBA = [245, 158, 11, 1.0];

export const PROGRESS_BAR_BACKGROUND_COLOR = '#f3f4f7';
export const PROGRESS_BAR_BACKGROUND_COLOR_RGBA = [243, 244, 247, 255];
export const DISABLE_COLOR_RGBA = [51, 50, 62, 0.6];
export const TOOLTIP_TEXT_COLOR_LIGHT = 'rgba(51, 50, 62, 0.92)';
export const TOOLTIP_BACKGROUND_COLOR_LIGHT = '#ffffff';
export const TOOLTIP_TEXT_COLOR_DARK = '#ffffff';
export const TOOLTIP_BACKGROUND_COLOR_DARK = 'rgba(0, 0, 0, 0.8)';
export const TRANSPARENT_COLOR_RGBA = [0, 0, 0, 0];

export const HALO_FILL_ALPHA = 55;
export const HALO_BORDER_ALPHA = 130;

export const AVAILABLE_COLOR_RGB = AVAILABLE_COLOR_RGBA.slice(0, 3);
export const ALLOCATED_COLOR_RGB = ALLOCATED_COLOR_RGBA.slice(0, 3);
export const UNAVAILABLE_COLOR_RGB = UNAVAILABLE_COLOR_RGBA.slice(0, 3);
export const UNAVAILABLE_ORANGE_COLOR_RGB = UNAVAILABLE_COLOR_ORANGE_RGBA.slice(0, 3);
export const DISABLE_COLOR_RGB = DISABLE_COLOR_RGBA.slice(0, 3);

export const PLANNER_INDEX_SEGMENTS_COLORS = ['bg-purple-400', 'bg-purple-500', 'bg-purple-600', 'bg-purple-800'];
export const PLANNER_INDEX_SEGMENTS_BORDER_COLORS = [
  'border-purple-500',
  'border-purple-600',
  'border-purple-700',
  'border-purple-950',
];

export const PLANNER_INDEX_SEGMENT_COLOR_RGB = {
  IS_ZERO_RGB: [159, 158, 162], // gray
  LESS_THAN_RGB: [161, 115, 246], // purple-500
  FIRST_RANGE_RGB: [110, 46, 228], // purple-600
  SECOND_RANGE_RGB: [81, 23, 190], // purple-700
  HIGHER_THAN_RGB: [62, 26, 130], // purple-900
  TEXT_LIGHT: [255, 255, 255], // white
};
